import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function DeleteModal({ showdt, handleCloseDt, handledelete }) {
  return (
    <Modal
      show={showdt}
      size="md"
      onHide={handleCloseDt}
      centered
      backdrop="static"
      className="add_subproduct msl_model"
    >
     <Modal.Header className="border-0 justify-content-center text-center">
        <Modal.Title className="font_blue_20 font-600 text-center">Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center"><p className="font_blue_18">Are you sure you want to delete this record ?</p></Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button variant="danger" className="success_btn" onClick={handledelete}>
          Delete
        </Button>
        <Button variant="secondary" className="cancel_btn" onClick={handleCloseDt}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
